import React, { } from 'react';
import Button from '@mui/material/Button';
import { Dialog as DialogMaterial } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';

export default function Dialog({ openDialog, setOpenDialog, title, description }) {

    const handleClose = () => {
        setOpenDialog(false);
    };

    return (
        <DialogMaterial open={openDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            <DialogContent>

                <Typography>
                    {description}
                </Typography>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
            </DialogActions>
        </DialogMaterial>
    );
}